import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Row, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { AgreementForCustomerSelect } from '~/components/AgreementForCustomerSelect/AgreementForCustomerSelect';
import { useRelationship } from '~/hooks/reactQuery/queries/useRelationship';
import { useLocaleKeys } from '~/i18n';
import BillingHub from '~/pages/AgreementMinisite/BillingHub/BillingHub';
import { useFetchRelationshipSummaries } from '~/pages/GlobalBillingHub/hooks/useFetchRelationshipSummaries';
import styles from './UpcomingInvoicesTab.module.scss';
import { getActiveAgreementIds } from './UpcomingInvoicesTab.utils';
export const GetUpcomingInvoicesTabTID = (parentTestId)=>getTestIds(parentTestId);
export function UpcomingInvoicesTab(param) {
    let { clientId, onBillClient } = param;
    var _ref;
    const { UpcomingInvoicesTabTestIds: TID } = useMemo(()=>GetUpcomingInvoicesTabTID(), []);
    const { t: texts } = useLocaleKeys('pages.clientDetail.tabContent.upcomingInvoices');
    const navigate = useNavigate();
    const location = useLocation();
    const { summaries } = useFetchRelationshipSummaries({
        refreshOnHookMount: true
    });
    const allOptionIds = useMemo(()=>getActiveAgreementIds(summaries, clientId), [
        summaries,
        clientId
    ]);
    const [selectedId, setSelectedId] = useState(null);
    const effectiveSelectedId = (_ref = selectedId !== null && selectedId !== void 0 ? selectedId : allOptionIds[0]) !== null && _ref !== void 0 ? _ref : null;
    const onAgreementChange = (id)=>{
        setSelectedId(id);
        const params = new URLSearchParams(location.search);
        params.delete('selectedDate');
        navigate({
            search: params.toString()
        }, {
            replace: true
        });
    };
    if (allOptionIds.length === 0) {
        return /*#__PURE__*/ _jsx(Box, {
            testId: TID.Root(),
            width: "100%",
            padding: "24px 0 0 0",
            children: /*#__PURE__*/ _jsxs(Row, {
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                gap: 4,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: TID.EmptyNoAgreement(),
                        children: texts.emptyNoAgreement()
                    }),
                    /*#__PURE__*/ _jsx(TextButton, {
                        bi: {
                            name: 'client_detail_upcoming_invoices_bill_client'
                        },
                        testId: TID.EmptyNoAgreementCta(),
                        skin: "primary",
                        weight: "normal",
                        underline: "none",
                        onClick: onBillClient,
                        children: texts.emptyNoAgreementCta()
                    })
                ]
            })
        });
    }
    if (effectiveSelectedId == null) return null;
    const showAgreementSelector = allOptionIds.length > 1;
    return /*#__PURE__*/ _jsx(Box, {
        testId: TID.Root(),
        className: styles.root,
        children: /*#__PURE__*/ _jsx(BillingHubForAgreement, {
            relationshipId: effectiveSelectedId,
            headerLeftSlot: showAgreementSelector ? /*#__PURE__*/ _jsx(AgreementForCustomerSelect, {
                customerId: clientId,
                selectedRelationshipId: effectiveSelectedId,
                onChange: onAgreementChange,
                testId: TID.AgreementSelector(),
                bi: {
                    name: 'client_detail_upcoming_invoices_agreement_selector'
                },
                label: texts.agreementLabel()
            }) : undefined
        })
    });
}
function BillingHubForAgreement(param) {
    let { relationshipId, headerLeftSlot } = param;
    const { relationship, refresh, isLoading } = useRelationship(relationshipId);
    if (isLoading || relationship == null) return null;
    return /*#__PURE__*/ _jsx(BillingHub, {
        agreement: relationship,
        isVendor: true,
        refreshAgreement: refresh,
        headerLeftSlot: headerLeftSlot,
        inlineHeader: true,
        disableAppcues: true
    }, relationshipId);
}
